import react, { useState, useEffect } from "react";
import { KTIcon, toAbsoluteUrl } from "../../../_metronic/helpers";
import {
  deleteStates,
  getStates,
  saveStates,
  updateStates,
} from "./core/_requests";
import { toast } from "react-toastify";
import { PageTitle } from "../../../_metronic/layout/core/PageData";
import { Paginator } from "primereact/paginator";

const State = () => {
  const [states, setStates] = useState<any[]>([]);
  const [pageData, setPageData] = useState<any[]>([]);
  const [statesForSearch, setStatesForSearch] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [editId, setEditId] = useState("");
  const [search, setSearch] = useState("");
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const statesList = async () => {
    setLoading(true);
    const response = await getStates();
    setStates(response.output);
    setStatesForSearch(response.output);
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let stateName = (document.getElementById("state_name") as HTMLInputElement)
      .value;
    if (stateName.length > 0) {
      const response = await saveStates({ name: stateName });
      if (response.status == 200) {
        (document.getElementById("state_name") as HTMLInputElement).value = "";
        document.getElementById("atom_state_add_modal_close")?.click();
        statesList();
        toast.success(response.message, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        toast.error(response.message, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else {
      toast.warn("Please Enter State name..", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const handleDelete = async () => {
    const response = await deleteStates(deleteId);
    if (response.status == 200) {
      setDeleteId("");
      document.getElementById("atom_state_delete_modal_close")?.click();
      statesList();
      toast.success(response.message, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(response.message, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const handleUpdate = async (id) => {
    let stateName = (
      document.getElementById("state_name_update" + id) as HTMLInputElement
    ).value;
    if (stateName.length > 0) {
      const response = await updateStates(id, { name: stateName });
      if (response.status == 200) {
        setEditId("");
        statesList();
        toast.success(response.message, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        setEditId("");
        toast.error(response.message, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else {
      toast.warn("Please Enter State name..", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  useEffect(() => {
    if (search.length > 0) {
      const states = statesForSearch.filter((p) =>
        p.name?.toLowerCase().includes(search)
      );
      console.log("foghiuehtoeirhtpeoirth", states);
      setStates(states);
    } else {
      setStates(statesForSearch);
    }
  }, [search]);

  useEffect(() => {
    statesList();
  }, []);

  useEffect(() => {
    let page = states?.slice(first, first + rows);
    setPageData(page);
  }, [first, rows, states]);

  return (
    <>
      <PageTitle>Business Settings</PageTitle>
      <div className="modal fade" id="atom_state_add_modal" aria-hidden="true">
        <div className="modal-dialog mw-550px">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0 justify-content-between align-items-center">
              <div className="text-center">
                <h3 className="mb-3">Add State</h3>
              </div>
              <div
                className="btn btn-sm btn-icon btn-active-color-primary"
                data-bs-dismiss="modal"
                id="atom_state_add_modal_close"
              >
                <KTIcon iconName="cross" className="fs-1" />
              </div>
            </div>
            <div className="modal-body scroll-y pb-10 pt-5">
              <form onSubmit={handleSubmit}>
                <input
                  name="state_name"
                  id="state_name"
                  className="form-control form-control-solid mb-8"
                  placeholder="Enter State Name.."
                />
                <span className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary me-3"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-sm btn-primary">
                    Save
                  </button>
                </span>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="atom_state_delete_modal"
        aria-hidden="true"
      >
        <div className="modal-dialog mw-550px">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0 justify-content-between align-items-center">
              <div className="text-center">
                <h3 className="mb-3">Confirmation</h3>
              </div>
              <div
                className="btn btn-sm btn-icon btn-active-color-primary"
                data-bs-dismiss="modal"
                id="atom_state_delete_modal_close"
              >
                <KTIcon iconName="cross" className="fs-1" />
              </div>
            </div>
            <div className="modal-body scroll-y pb-10">
              <p>Are you sure want to delete?</p>
              <span className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary me-3"
                  data-bs-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  onClick={() => handleDelete()}
                >
                  Yes
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="w-100 h-100">
          <div className="d-flex justify-content-center flex-column align-items-center h-100">
            <div className="spinner-border taskloader" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="card">
          <div className="card-header d-flex align-items-center">
            <h3>States</h3>
            <span className="d-flex">
              <span className="position-relative me-3">
                <input
                  onChange={(e) => setSearch(e.target.value?.toLowerCase())}
                  className="form-control form-control-sm form-control-solid mw-200px"
                  placeholder="Search.."
                />
                <i className="bi bi-search fs-3 me-3 position-absolute top-25 end-0"></i>
              </span>
              <button
                className="btn btn-sm btn-primary me-2 text-nowrap"
                data-bs-toggle="modal"
                data-bs-target="#atom_state_add_modal"
                onClick={() => {
                  (
                    document.getElementById("state_name") as HTMLInputElement
                  ).value = "";
                  setDeleteId("");
                  setSearch("");
                  setEditId("");
                }}
              >
                <i className="bi bi-plus-lg"></i> Add State
              </button>
            </span>
          </div>
          <div className="card-body pt-0">
            <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
              <thead>
                <tr className="text-start text-muted fw-bolder fs-7 text-uppercase gs-0">
                  <th>Sl.No</th>
                  {/* <th>Tag</th> */}
                  <th>State</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody className="text-gray-600 fw-bold">
                {states.length > 0 ? (
                  pageData.map((item, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1 + first}</td>
                        {/* <td>
                            <div className='table_item_preview bg-secondary'>
                                {item.name}
                            </div>
                        </td> */}
                        <td>
                          {editId == item.id ? (
                            <input
                              name="state_name_update"
                              defaultValue={item.name}
                              id={"state_name_update" + item.id}
                              className="form-control form-control-solid"
                              placeholder="Enter State Name.."
                            />
                          ) : (
                            <span>{item.name}</span>
                          )}
                        </td>
                        <td className="text-center">
                          {editId == item.id ? (
                            <>
                              <button
                                className="btn btn-sm btn-secondary btn-active-color-primary btn-icon me-2"
                                onClick={() => handleUpdate(item.id)}
                              >
                                <i className="bi bi-check-lg fs-3"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-secondary btn-active-color-danger btn-icon me-2"
                                onClick={() => setEditId("")}
                              >
                                <i className="bi bi-x-lg fs-4"></i>
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                className="btn btn-sm btn-secondary btn-active-color-primary btn-icon me-2"
                                onClick={() => {
                                  setEditId(item.id);
                                }}
                              >
                                <i className="bi bi-pencil-fill"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-secondary btn-active-color-danger btn-icon"
                                data-bs-toggle="modal"
                                data-bs-target="#atom_state_delete_modal"
                                onClick={() => setDeleteId(item.id)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={7}>
                      <div className="d-flex text-center w-100 align-content-center justify-content-center">
                        No matching records found
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="table_paginator mt-3 d-flex justify-content-end">
              <Paginator
                first={first}
                rows={rows}
                totalRecords={states.length}
                rowsPerPageOptions={[10, 50, 100, 500, 1000]}
                onPageChange={onPageChange}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default State;
